const Homepage = () => import('@/views/Homepage.vue');
const Instances = () => import('@/views/Instances.vue');
const InstanceDetails = () => import('@/views/InstanceDetails.vue');
const InstanceAdd = () => import('@/views/InstanceAdd.vue');
const InstanceAddPlugin = () => import('@/views/InstanceAddPlugin.vue');
const Sandbox = () => import('@/views/Sandbox.vue');
const Dashboard = () => import('@/views/Dashboard.vue');
const Bills = () => import('@/views/Bills.vue');
const AllNotifications = () => import('@/views/AllNotifications.vue');

export default [
  {
    path: '/',
    redirect: { path: '/dashboard' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: Homepage,
  },
  {
    path: '/instances',
    name: 'instances',
    component: Instances,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/instances/:id',
    name: 'instanceDetails',
    component: InstanceDetails,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/instances/add',
    name: 'instanceAdd',
    component: InstanceAdd,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/instances/:id/plugin/add',
    name: 'instanceAddPlugin',
    component: InstanceAddPlugin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/sandbox',
    name: 'sandbox',
    component: Sandbox,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/bills',
    name: 'bills',
    component: Bills,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: AllNotifications,
    meta: {
      requiresAuth: true,
    },
  },
];
